import script from "./MobileRouteFlow.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileRouteFlow.vue?vue&type=script&setup=true&lang=js"

import "./MobileRouteFlow.vue?vue&type=style&index=0&id=3915d34e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3915d34e"]])

export default __exports__